import Swiper from 'swiper';

function init( node ) {
	const contents = node.querySelectorAll( '.stacked-card-slider__text' );
	const swiper   = node.querySelector('.stacked-card-slider__swiper' );
	const nextEl   = node.querySelector('.stacked-card-slider__next');
	const prevEl   = node.querySelector('.stacked-card-slider__prev');

	const inst = new Swiper(
		swiper,
		{
			effect: "cards",
			cardsEffect: {
				perSlideOffset: 15,
				perSlideRotate: 0,
				rotate: false,
				slideShadows: true,
			},
			speed: 250,
			noSwiping: false,
			loop: false,
			grabCursor: false,
			longSwipes: false,
			preventInteractionOnTransition: true,
			navigation: {
				nextEl,
				prevEl,
			},
			on: {
				init: (t) => {
					contents[0].classList.add( 'is-active' );
				},
				slideChange: (el) => {
					for ( const [ index, content ] of contents.entries() ) {
						if ( index === el.activeIndex ) {
							setTimeout( () => content.classList.add( "is-active" ), 350 );
						} else {
							content.classList.remove( "is-active" );
						}
					}
				}
			}
		}
	);

	return inst;
}

for ( const node of document.querySelectorAll( '.stacked-card-slider' ) ) {
	init( node );
}
